(function () {
  'use strict';

  var productJson = document.querySelector('[data-product-json]');
  if (!productJson) return;

  var product;
  try { product = JSON.parse(productJson.textContent); } catch (e) { return; }

  var form = document.querySelector('[data-product-form]');
  var variantIdInput = document.querySelector('[data-variant-id]');
  var priceDisplay = document.querySelector('[data-product-price]');
  var priceCurrent = document.querySelector('[data-product-price-current]');
  var priceCompare = document.querySelector('[data-product-price-compare]');
  var addToCartBtn = document.querySelector('[data-add-to-cart]');
  var stickyBar = document.querySelector('[data-sticky-bar]');
  var stickyPrice = document.querySelector('[data-sticky-price]');
  var stickyAddBtn = document.querySelector('[data-sticky-add-to-cart]');
  var stickyPack = document.querySelector('[data-sticky-pack]');

  /* --- Pack / short description: move from description into buy column --- */
  var packSlot = document.querySelector('[data-pack-slot]');
  var shortDescEl = document.querySelector('.product-description__body .product-short-desc');
  if (packSlot && shortDescEl) {
    packSlot.appendChild(shortDescEl);
    if (stickyPack) {
      stickyPack.textContent = shortDescEl.textContent.replace(/\s+/g, ' ').trim();
      stickyPack.hidden = false;
    }
  }

  function formatMoney(cents) {
    var n = Number(cents);
    if (!Number.isFinite(n)) return '';
    var iso = (window.DCR && window.DCR.currency) || 'USD';
    try {
      return new Intl.NumberFormat(undefined, {
        style: 'currency',
        currency: iso
      }).format(n / 100);
    } catch (e) {
      return '$' + (n / 100).toFixed(2);
    }
  }

  /* --- Variant selection --- */
  var variantCards = document.querySelectorAll('[data-variant-card]');

  variantCards.forEach(function (card) {
    card.addEventListener('click', function () {
      var radio = card.querySelector('.variant-card__radio');
      if (radio.disabled) return;

      variantCards.forEach(function (c) { c.classList.remove('is-selected'); });
      card.classList.add('is-selected');
      radio.checked = true;

      var variantId = card.getAttribute('data-variant-id');
      var variantPrice = card.getAttribute('data-variant-price');
      var variantComparePrice = card.getAttribute('data-variant-compare-price');
      var variantAvailable = card.getAttribute('data-variant-available') === 'true';

      if (variantIdInput) variantIdInput.value = variantId;

      if (priceCurrent) {
        priceCurrent.textContent = formatMoney(variantPrice);
      } else if (priceDisplay) {
        priceDisplay.textContent = formatMoney(variantPrice);
      }

      if (priceCompare) {
        var compareNumber = Number(variantComparePrice);
        var priceNumber = Number(variantPrice);
        if (Number.isFinite(compareNumber) && compareNumber > priceNumber) {
          priceCompare.textContent = formatMoney(compareNumber);
          priceCompare.classList.remove('is-hidden');
        } else {
          priceCompare.textContent = '';
          priceCompare.classList.add('is-hidden');
        }
      }

      if (stickyPrice) stickyPrice.textContent = formatMoney(variantPrice);

      if (addToCartBtn) {
        addToCartBtn.disabled = !variantAvailable;
        addToCartBtn.textContent = variantAvailable ? 'Add to Cart' : 'Sold Out';
      }
    });
  });

  /* --- Image gallery --- */
  var mainImg = document.querySelector('[data-gallery-main-img]');
  var thumbs = document.querySelectorAll('[data-gallery-thumb]');

  thumbs.forEach(function (thumb) {
    thumb.addEventListener('click', function () {
      thumbs.forEach(function (t) { t.classList.remove('is-active'); });
      thumb.classList.add('is-active');

      if (mainImg) {
        mainImg.src = thumb.getAttribute('data-image-src');
        var srcset = thumb.getAttribute('data-image-srcset');
        if (srcset) {
          mainImg.srcset = srcset;
        }
        mainImg.alt = thumb.getAttribute('data-image-alt');
      }
    });
  });

  /* --- Quantity stepper --- */
  var qtyInput = document.querySelector('[data-qty-input]');
  var qtyMinus = document.querySelector('[data-qty-minus]');
  var qtyPlus = document.querySelector('[data-qty-plus]');

  if (qtyMinus) {
    qtyMinus.addEventListener('click', function () {
      var val = parseInt(qtyInput.value, 10) || 1;
      qtyInput.value = Math.max(1, val - 1);
    });
  }

  if (qtyPlus) {
    qtyPlus.addEventListener('click', function () {
      var val = parseInt(qtyInput.value, 10) || 1;
      qtyInput.value = val + 1;
    });
  }

  /* --- AJAX Add to Cart --- */
  function addToCart(variantId, quantity) {
    return fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        items: [{ id: parseInt(variantId, 10), quantity: parseInt(quantity, 10) }]
      })
    })
    .then(function (res) { return res.json(); })
    .then(function (data) {
      updateCartCount();
      showCartNotification();
      return data;
    });
  }

  function updateCartCount() {
    fetch('/cart.js')
      .then(function (res) { return res.json(); })
      .then(function (cart) {
        var badges = document.querySelectorAll('[data-cart-count]');
        badges.forEach(function (badge) {
          badge.textContent = cart.item_count;
          if (cart.item_count > 0) {
            badge.style.display = '';
          }
        });
      });
  }

  function showCartNotification() {
    var notification = document.getElementById('cart-notification');
    if (!notification) return;

    notification.innerHTML =
      '<div class="cart-notification__inner">' +
        '<span class="cart-notification__icon"><svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="2" stroke="currentColor"><path stroke-linecap="round" stroke-linejoin="round" d="M4.5 12.75l6 6 9-13.5"/></svg></span>' +
        '<span class="cart-notification__text">Added to cart!</span>' +
      '</div>' +
      '<div class="cart-notification__actions">' +
        '<a href="/cart" class="btn btn--sm btn--primary">View Cart</a>' +
        '<button type="button" class="btn btn--sm btn--secondary" data-close-notification>Continue Shopping</button>' +
      '</div>';

    notification.classList.add('is-visible');
    notification.setAttribute('aria-hidden', 'false');

    var closeBtn = notification.querySelector('[data-close-notification]');
    if (closeBtn) {
      closeBtn.addEventListener('click', function () {
        notification.classList.remove('is-visible');
        notification.setAttribute('aria-hidden', 'true');
      });
    }

    setTimeout(function () {
      notification.classList.remove('is-visible');
      notification.setAttribute('aria-hidden', 'true');
    }, 5000);
  }

  if (form) {
    form.addEventListener('submit', function (e) {
      e.preventDefault();
      var id = variantIdInput ? variantIdInput.value : form.querySelector('[name="id"]').value;
      var qty = qtyInput ? qtyInput.value : 1;
      addToCartBtn.disabled = true;
      addToCartBtn.textContent = 'Adding...';
      addToCart(id, qty).then(function () {
        addToCartBtn.disabled = false;
        addToCartBtn.textContent = 'Add to Cart';
      }).catch(function () {
        addToCartBtn.disabled = false;
        addToCartBtn.textContent = 'Add to Cart';
      });
    });
  }

  if (stickyAddBtn) {
    stickyAddBtn.addEventListener('click', function () {
      var id = variantIdInput ? variantIdInput.value : '';
      var qty = qtyInput ? qtyInput.value : 1;
      if (id) addToCart(id, qty);
    });
  }

  /* --- Mobile sticky bar visibility --- */
  if (stickyBar && addToCartBtn) {
    var observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        stickyBar.classList.toggle('is-visible', !entry.isIntersecting);
      });
    }, { threshold: 0 });
    observer.observe(addToCartBtn);
  }
})();
